import { getCookie } from "@/utils/cookies"

export const ifNotAuthenticated = (routes) => {
  return routes.map((route) => {
    return {
      ...route,
      beforeEnter: (to, from, next) => {
        const token = getCookie("auth_access_mpo")

        if (!token) {
          next()
          return
        }

        next("/")
      }
    }
  })
}

export const ifAuthenticated = (routes) => {
  return routes.map((route) => {
    return {
      ...route,
      beforeEnter: (to, from, next) => {
        const token = getCookie("auth_access_mpo")

        if (token) {
          next()
          return
        }

        next("/sign-in")
      }
    }
  })
}
